import React from 'react';

import Group from '@lightspeed/cirrus-group';
import Modal, { ModalBody, ModalFooter, ModalHeader } from '@lightspeed/cirrus-modal';
import Text from '@lightspeed/cirrus-text';
import { Button } from '@lightspeed/flame/Button';
import axios from 'axios';
import { withFormik } from 'formik';
import get from 'lodash/get';

const SyncProductsModal = ({ handleSubmit, isSubmitting, onClose }) => (
  <Modal className="cirrus" isOpen onRequestClose={() => onClose()}>
    <ModalHeader onCloseClicked={() => onClose()}>Sync eCom Item Data</ModalHeader>
    <ModalBody>
      <Text body color="gray">
        Are you sure you want to <strong>Sync eCom Item Data?</strong>
      </Text>
    </ModalBody>
    <ModalFooter>
      <Group className="cr-justify-end">
        <Button onClick={() => onClose()}>No, don&#39;t do it</Button>
        <Button variant="secondary" fill loading={isSubmitting} onClick={handleSubmit}>
          Yes, do it
        </Button>
      </Group>
    </ModalFooter>
  </Modal>
);

const enhancedSyncProductsModal = withFormik({
  handleSubmit: async (values, formikBag) => {
    formikBag.setSubmitting(true);

    const { accountId } = formikBag.props;

    try {
      await axios.post(`/staff/accounts/${accountId}/ecom/resync-products`);
      formikBag.props.onConfirm({ message: 'Resync Products pushed to queue' });
    } catch (e) {
      window.alertUser(get(e, 'response.data.errors[0].detail') || 'An error occurred');
    }

    formikBag.setSubmitting(false);
    formikBag.props.onClose();
  },
})(SyncProductsModal);

export default enhancedSyncProductsModal;
